import styles from "./Info.module.css";

const lorem =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

export default function Info({ title, description, quantity }) {
  return (
    <main className={styles.main}>
      <div className={styles.title}>
        {title || "Prois saizvod ima jako i m"}
      </div>
      <div className={styles.devider} />
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: description || lorem }}
      ></div>
      {quantity > 0 && (
        <div className={styles.quantity}>Količina: {quantity}</div>
      )}
    </main>
  );
}
